import { getUetTagItemStyles } from './uet-tag-item-styles';

export const getPageMenuStyles = ({ pageMenu = {} }, { palette = {} }) => ({
  ...getUetTagItemStyles({ pageMenu }, { palette }),

  treeViewContainer: {
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 'calc(100vh - 200px) !important',
    color: '#f3f2f1',
    backgroundColor: '#fff',
    flex: '1 1 1px',
    maxHeight: 'calc(100vh - 160px)',
    '& .ReactVirtualized__Grid': {
      overflowY: 'hidden !important',
      '&:hover': {
        overflowY: 'visible !important',
      },
      '& .ReactVirtualized__Grid__innerScrollContainer': {
        overflow: 'hidden !important',
        '& .tree-node button': {
          background: '#fff !important',
        },
      },
    },
  },
  statusIconContainer: {
    width: 12,
    height: 12,
    marginLeft: 12,
    marginTop: 4,
    marginBottom: 12,
    marginRight: 12,
  },
  labelContainer: {
    color: palette.white,
  },
});
